import React from 'react';
import { Question } from '../Beneficiary/BeneficiaryLanding';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import {
  getQuestionOptions,
  serviceDeliveryQuestionId,
  serviceSubTypeQuestionId,
} from './options';
import { Answer } from '../Review/utils';
import ActivitiesRender from './ActivitiesRender';
import { GuidanceTextResponse } from '../utils';
import SectionLoadError from '../SectionLoadError';

interface ActivitiesProps {
  reportId: number | string;
  question: Question | undefined;
  guidanceText: GuidanceTextResponse;
  onPreviousSection: () => unknown;
  programName: string;
  questions: Question[];
  savedAnswers: Answer[];
  beneficiaryTerm?: string;
  intermediaries?: string;
  allValues?: { [id: number]: string | undefined };
  isReportPassed?: boolean;
  reloadAnswers: () => unknown;
  handleValueChange: (questionId: number, value: string | undefined) => unknown;
  isProgramLevelQuestion?: boolean;
}

const Activities: React.FC<ActivitiesProps> = ({
  reportId,
  allValues,
  question,
  programName,
  guidanceText,
  beneficiaryTerm,
  intermediaries,
  reloadAnswers,
  handleValueChange,
  isProgramLevelQuestion,
}) => {
  if (!allValues || !question) {
    return <TrueImpactLoading />;
  }

  const value = allValues[question.dbId];
  const serviceDelivery = allValues[serviceDeliveryQuestionId];
  const serviceSubType = allValues[serviceSubTypeQuestionId];

  const questionOptions = getQuestionOptions(
    question.dbId,
    serviceDelivery,
    serviceSubType,
  );

  if (!questionOptions) {
    return (
      <SectionLoadError
        reportId={reportId}
        sectionId="activities"
        onResetSuccess={reloadAnswers}
      />
    );
  }

  return (
    <ActivitiesRender
      value={value}
      question={question}
      programName={programName}
      beneficiaryTerm={beneficiaryTerm}
      intermediaries={intermediaries}
      serviceSubType={serviceSubType}
      questionOptions={questionOptions}
      guidanceText={guidanceText}
      handleValueChange={handleValueChange}
      isProgramLevelQuestion={isProgramLevelQuestion}
    />
  );
};

export default Activities;
